import API from "../../services/API/Social";
import { Stack, CircularProgress, Button} from "@mui/material";
import Avatar from "../Tools/Avatar";
import { useQuery } from "react-query";
import { useTheme } from '@mui/material/styles';
import Tip from "../Tools/Tip";
import { useState } from "react";
import Confirm from "../Tools/Confirm";
import { useQueryClient, useMutation } from "react-query";
import { timeAgo } from "../../services/timeAgo";
import { useContext } from "react";
import UserContext from "../../services/Context/UserContext";
import { txt } from "../../services/translation";

export default function Comments({post, onClose, queryKey, page, onReply}){

    const commentsKey = 'comments' + post.id;

    const {data, isSuccess, isLoading} = useQuery(commentsKey,
        () => API.getPostComments(post.id).then(r => r.data)
    )

    return <div>

        <Stack sx={{mt: 1}}>
            {isSuccess && data.map(c =>
                <Comment 
                    key={c.id} 
                    comment={c} 
                    post={post} 
                    queryKey={queryKey} 
                    page={page}
                    onReply={onReply}
                />
            )}
        </Stack>

        {isLoading && <Stack direction='row' justifyContent='center' sx={{mt: 3}}>
            <CircularProgress size={24} />
        </Stack>}

        {false && isSuccess && 
            <Button onClick={onClose} sx={{ mt: 1 }}>
                {txt('hideCommentsButtonLabel')}
            </Button>
        }
    
    </div>
}



function Comment({comment, post, queryKey, page, onReply}){

    const {user} = useContext(UserContext)

    const theme = useTheme();

    const [deleteConfirm, setDeleteConfirm] = useState(false)

    const commentsKey = 'comments' + post.id;

    const queryClient = useQueryClient();

    const deleteComment = useMutation({

        mutationFn: id => API.deleteComment(id),

        onMutate: async id => {
            await queryClient.cancelQueries({ queryKey: queryKey })
            await queryClient.cancelQueries({ queryKey: [commentsKey] })

            const previousPosts = queryClient.getQueryData(queryKey)
            const previousComments = queryClient.getQueryData([commentsKey])

            queryClient.setQueryData(queryKey, old => {
                const idx = old.pages[page - 1].data.findIndex(p => p.id === post.id);

                let newPost = {...post};
                newPost.commentsCount--;

                let copy = {...old};
                copy.pages[page - 1].data[idx] = newPost;

                return copy;
            })

            queryClient.setQueryData([commentsKey], old => {
                let copy = [...old];
                copy = copy.filter(c => c.id !== id);
                console.log(commentsKey, copy);
                return copy;
            })
                

            setDeleteConfirm(false);

            return { previousPosts, previousComments }
        },
        onError: (e, data, context) => {
            console.log(e, data)
            queryClient.setQueryData(queryKey, context.previousPosts)
            queryClient.setQueryData([commentsKey], context.previousComments)
        },
        onSettled: () => {
            queryClient.invalidateQueries({ queryKey: queryKey })
            queryClient.invalidateQueries({ queryKey: [commentsKey] })
        },
    })


    return <>
        <Stack direction='row' sx={{mt: 2}} className='social-comment-container'>

            <Avatar 
                initials={comment.author?.initials}
                color={comment.author?.category?.color}
                size={36}
            />

            <div className='social-comment' data-id={comment.id}>
                <span><b>{comment.author?.name}</b> <small style={{marginLeft: 5}}>{timeAgo(comment.createdAt)}</small></span>
                <p style={{whiteSpace: "pre-wrap"}}>
                    {comment.recipient && 
                        <span style={{color: theme.palette.primary.main}}>{comment.recipient.at} </span>
                    }
                    {comment.content}
                </p>
            </div>

            <div className='social-comment-actions'>
                <Tip type='back' title='Répondre' onClick={() => onReply(comment.author)}/>
        
                {(comment.mine || user.admin) && 
                    <Tip type='delete' onClick={() => setDeleteConfirm(true)}/>
                }
            </div>

                
        </Stack>

        {deleteConfirm && 
            <Confirm 
                open={deleteConfirm ? true : false} 
                onClose={() => setDeleteConfirm(false)} 
                onConfirm={() => deleteComment.mutate(comment.id)}
            >
                {txt('confirmDeleteCommentText')}
            </Confirm>
        }
    </>
}